import React, { Component } from 'react'
import { connect } from 'react-redux';
import Service from '../../services';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import { BoardsIconInActive, GradesIcon, MailIcon } from '../svgIcons';
import { Toast } from 'primereact/toast';
import LoadingComponent from '../loadingComponent';
import { getBoardsData } from '../../store/actions';
import { baseUrlAdmin } from '../../store/apiConstants';
import { userAssignedBoards } from '../../store/selectors/userAssignedBoards';
import { cloneDeep } from 'lodash';

class BoardToSectionDDNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boardId: null,
            classId: null,
            groupId: null,
            branchId: null,
            classes: [],
            branches: [],
            curriculumInfo: {},
        };
        this.service = new Service()
    }

    componentDidMount() {
        // this.props.getBoardsData(true);
    }

    // Helper method to check if user is a teacher
    isTeacher = () => {
        // Check user type from localStorage
        const userType = localStorage.getItem('type');
        
        // Only if type is 'teacher', check for assignedSubjects
        if (userType === 'teacher') {
            return this.props.userInfo?.assignedSubjects && this.props.userInfo.assignedSubjects.length > 0;
        }
        
        // For all other types (admin, staff, etc.), return false (they get all sections)
        return false;
    }

    // Helper method to remove duplicates based on unique ID
    removeDuplicates = (array, idKey) => {
        if (!array || array.length === 0) return [];
        
        const seen = new Set();
        return array.filter(item => {
            const id = item[idKey];
            if (seen.has(id)) {
                return false;
            }
            seen.add(id);
            return true;
        });
    }

    // Filter boards based on user's assigned boards
    getFilteredBoards = () => {
        const { userInfo, boards } = this.props;

        // If user is admin, return all boards
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(boards || [], 'boardId');
        }

        let filteredBoards = boards || [];

        // For teachers, filter by assigned boards
        if (this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
            filteredBoards = filteredBoards.filter(board =>
                userInfo?.boardId.includes(board.boardId)
            );
        }
        // For non-admin, non-teacher users, filter by assigned boards if available
        else if (!this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
            filteredBoards = filteredBoards.filter(board =>
                userInfo?.boardId.includes(board.boardId)
            );
        }

        // Remove duplicate boards by boardId
        return this.removeDuplicates(filteredBoards, 'boardId');
    }

    // Filter branches based on user's assigned branches
    getFilteredBranches = (assignedBranches) => {
        const { userInfo, branchData } = this.props;

        // Map assignedBranches (IDs) to actual branch objects
        let branches = assignedBranches?.map((branchId) =>
            branchData?.find((branch) => branch.key === branchId)
        ).filter(Boolean) || []; // Filter out any undefined values

        // If user is admin, return all mapped branches
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(branches, 'key');
        }

        // For non-admin users, filter by assigned branches
        if (userInfo.branchs && userInfo.branchs.length > 0) {
            branches = branches.filter(branch =>
                userInfo.branchs.includes(branch.key)
            );
        }
        
        return this.removeDuplicates(branches, 'key');
    }

    // Filter sections based on user role
    getFilteredSections = (sections) => {
        const { userInfo } = this.props;

        // If user is admin, return all sections
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(sections || [], 'sectionId');
        }

        // If not a teacher, return all sections (no filtering needed)
        if (!this.isTeacher()) {
            return this.removeDuplicates(sections || [], 'sectionId');
        }

        // If teacher but no assignedSections, return empty array (no sections accessible)
        if (!userInfo?.sections || userInfo.sections.length === 0) {
            return [];
        }

        // For teachers with assignedSections, filter by assigned sections
       const filtered = sections.filter(section =>
                userInfo.sections.includes(section.sectionId)
            );
        
        return this.removeDuplicates(filtered, 'sectionId');
    }

    componentDidUpdate() {
        if (this.state.boardId == null && this.props.boards?.length > 0) {
            // Get filtered boards
            const filteredBoards = this.getFilteredBoards();

            if (filteredBoards.length === 0) {
                return; // No accessible boards for this user
            }

            if (this.props.defaultValues?.boardId && this.props.defaultValues?.classId) {
                const selectedBoard = filteredBoards.find(
                    (board) => board?.boardId === this.props.defaultValues.boardId
                );
                if (selectedBoard) {
                    const selectedClass = selectedBoard.classes.find(
                        (classd) => classd.classId === this.props.defaultValues.classId
                    );

                    // Get filtered branches
                    const branches = this.getFilteredBranches(selectedBoard?.assignedBranches);

                    this.setState({
                        classes: selectedBoard.classes,
                        boardId: selectedBoard.boardId,
                        selectedBoardName: selectedBoard.boardName,
                        classId: selectedClass?.classId,
                        selectedClass: selectedClass,
                        groupId: selectedClass?.groupId,
                        branches: branches, // Use filtered branches
                        selectedClassName: selectedClass?.className,
                    }, () => this.setDropdownsData());
                }
            } else {
                const selectedBoard = filteredBoards[0];
                if (selectedBoard?.classes?.length > 0) {
                    const selectedClass = selectedBoard.classes[0];

                    // Get filtered branches
                    const branches = this.getFilteredBranches(selectedBoard?.assignedBranches);

                    this.setState({
                        classes: selectedBoard.classes,
                        boardId: selectedBoard.boardId,
                        selectedBoardName: selectedBoard.boardName,
                        classId: selectedClass.classId,
                        selectedClass: selectedClass,
                        groupId: selectedClass.groupId,
                        branches: branches, // Use filtered branches
                        selectedClassName: selectedClass.className,
                    }, () => this.setDropdownsData());
                }
            }
        }
    }

    onChangeBoard = (boardId) => {
        if (this.props.disabledFields?.board) return;

        this.setState({
            classes: [], classId: null, curriculumInfo: null, branches: [], sections: []
        });

        const selectedBoard = this.props.boards?.find((board) => board?.boardId === boardId);

        // Get filtered branches
        const branches = this.getFilteredBranches(selectedBoard?.assignedBranches);

        // Remove duplicate classes
        const uniqueClasses = this.removeDuplicates(selectedBoard?.classes || [], 'classId');

        this.setState({
            classes: uniqueClasses,
            boardId,
            selectedBoardName: selectedBoard?.boardName,
            classId: '',
            selectedClass: {},
            groupId: '',
            branches: branches, // Set filtered branches
            selectedClassName: ''
        });
    };

    onChangeClass = (classId) => {
        if (this.props.disabledFields?.grade) return;

        const selectedClass = this.state?.classes?.find((classd) => classd.classId === classId);

        this.setState({
            classId: classId,
            selectedClass: selectedClass,
            groupId: selectedClass?.groupId,
            selectedClassName: selectedClass?.className,
            branchId: '',
            selectedbranchName: '',
            sections: [] // Reset sections when class changes
        });
    };

    onChangeBranch = (branchId) => {
        this.setState({
            sections: []
        });

        const selectedbranchName = this.state?.branches?.find(
            (branchd) => branchd.key === branchId
        )?.name;

        // Get all sections for this branch from the selected class
        let sections = this.state.selectedClass?.sections?.filter(
            (section) => section.branchId === branchId
        ) || [];

        // Apply user role-based section filtering
        sections = this.getFilteredSections(sections);

        this.setState({
            branchId: branchId,
            selectedbranchName: selectedbranchName,
            sections: sections,
            sectionId: '',
            selectedsectionName: '',
        }, () => this.setDropdownsData());  // Call setDropdownsData after state update
    };

    onChangeSection = (sectionId) => {
        const selectedSection = this.state.sections?.find(
            (sectiond) => sectiond.sectionId == sectionId
        );

        this.setState({
            sectionId: sectionId,
            selectedsectionName: selectedSection?.sectionName || '',
        }, () => this.setDropdownsData());
    };

    setDropdownsData = () => {
        let {
            boardId,
            classId,
            branchId,
            sectionId,
            selectedBoardName,
            selectedClassName,
            selectedbranchName,
            selectedsectionName
        } = this.state
        let returnData = {
            boardId,
            classId,
            branchId,
            sectionId,
            selectedBoardName,
            selectedClassName,
            selectedbranchName,
            selectedsectionName
        }
        this.props.setValues(returnData)
    }

    render() {
        const { disabledFields = {} } = this.props;
        
        // Get filtered boards for the dropdown options
        const filteredBoards = this.getFilteredBoards();

        return (
            <div>
                <div>
                    <div className='grid m-2'>
                        <div className="col-3">
                            <ClassetDropdown
                                required={true}
                                label={'Board'}
                                icon={<MailIcon />}
                                placeholder={'Select Board'}
                                options={filteredBoards}
                                value={this.state?.boardId}
                                onChange={(e) => this.onChangeBoard(e.value)}
                                optionLabel="boardName"
                                optionValue="boardId"
                                disabled={disabledFields.board}
                            />
                        </div>
                        <div className="col-3">
                            <ClassetDropdown
                                required={true}
                                label={'Grade'}
                                icon={<MailIcon />}
                                placeholder={'Select Grade'}
                                options={this.state?.classes}
                                value={this.state.classId}
                                onChange={(e) => this.onChangeClass(e.value)}
                                optionLabel="className"
                                optionValue="classId"
                                disabled={disabledFields.grade}
                            />
                        </div>
                        <div className="col-3">
                            <ClassetDropdown
                                required={true}
                                label={'Branch'}
                                icon={<MailIcon />}
                                placeholder={'Select Branch'}
                                options={this.state?.branches}
                                value={this.state.branchId}
                                onChange={(e) => this.onChangeBranch(e.value)}
                                optionLabel="name"
                                optionValue="key"
                                disabled={disabledFields.branch}
                            />
                        </div>
                        <div className="col-3">
                            <ClassetDropdown
                                required={false}
                                label={'Section'}
                                icon={<MailIcon />}
                                placeholder={'Select Section'}
                                options={this.state?.sections}
                                value={this.state.sectionId}
                                onChange={(e) => this.onChangeSection(e.value)}
                                optionLabel="sectionName"
                                optionValue="sectionId"
                                disabled={disabledFields.section}
                            />
                        </div>
                    </div>
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
                {this.state.isLoading && <LoadingComponent />}
            </div>
        )
    }
}

const mapStatesToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoards'),
    permissionIds: state.currentUserPerms?.permissionIds,
    userInfo: state.currentUserPerms?.userInfo || {},
});

export default connect(mapStatesToProps, { getBoardsData })(BoardToSectionDDNew);